import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { CurrencyServices } from '../services/currencyServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { makePersistable, stopPersisting } from 'mobx-persist-store';


export default class CurrenciesStore {    

    
  rootStore;
  currencies = [];
    currency = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          config: observable,
          setConfig: action,


          currencies: observable,
          currency: observable,
          getAll: action,
          //get:action,
          reset: action,
          save: action,
          remove: action,
          duplicate:action
      });

      makePersistable(this, { name: 'currenciesStore', properties: ['config'], storage: window.localStorage });

    }       

    remove = async (id) => {
        try {
            const data = await CurrencyServices.delete(id);
            runInAction(() => { toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("currency") })}`);});
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/});
        }
    }

    duplicate = async (id) => {
        try {
            const data = await CurrencyServices.duplicate(id);
            runInAction(() => { toast.success(`${i18n.t("wasDuplicated", { entity: i18n.t("currency") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }

    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await CurrencyServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("currency") })}`);
                });
            } catch (error) {}
        } else {
            try {
                const data = await CurrencyServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("currency") })}`);
                    this.reset();                    
                });
            } catch (error) {}
        }
    };

    reset = () => {        
        runInAction(() => this.currency = {});
    }
    
    /*get = async (id) => {
        runInAction(() => {
            this.template = items.filter(x => x.id == id)[0] || null;
        });
    }*/


    setConfig = (prop, c) => {
        //console.log("setConfig called: "+prop)
        this.config[prop] = c;
    }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await CurrencyServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.currencies = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.currencies = [];
            });
        }
    }

    getAll = async (page, filter, sort) => {
        try {            
            const data = await CurrencyServices.getAll({ page: page, filter: filter, sort: sort });
            runInAction(() => {this.currencies = data;})
        }
        catch (error) {
            runInAction(() => {this.currencies = [];});
        }
    }    

    getById = async (id) => {
        try {
            const data = await CurrencyServices.getById(id);
            runInAction(() => { this.currency = data;});
        } catch (error) {
            runInAction(() => { this.currency = {};})
        }
    };
}